import { Affiliate, getDefaultAffiliate } from './AffiliateModel'
import LocalizationStore from '../Stores/LocalizationStore'
import { AjvError, FormValidation } from 'react-jsonschema-form'
import * as moment from 'moment'
import * as React from 'react'
import { Link } from 'react-router-dom'
import Payment from './Payment'
import { toJS } from 'mobx'
import DateTimeHelper from '../Helpers/DateTimeHelper'
import { removeNull } from '../Helpers/ObjectHelper'
import { numOr0 } from '../Helpers/NumberHelper'
import { ITroubleEventSimple } from './TroubleEvent'
import { CreditCondition, ICreditCondition } from './CreditCondition'
import QuestionnairesStore from '../Stores/QuestionnairesStore'
import { CancelReason } from './CancelReasonModel'
import { CourtDecision } from './CourtDecision'

export function getQuestionnaireStatusClass(status: QuestionnaireStatus): string {
    switch (status) {
        case QuestionnaireStatus.Canceled:
            return 'cancel-status'
        case QuestionnaireStatus.Done:
            return 'done-status'
        case QuestionnaireStatus.Draft:
            return 'draft-status'
        case QuestionnaireStatus.Scored:
            return 'scored-status'
        case QuestionnaireStatus.InProgressCreditExpert:
        case QuestionnaireStatus.InProgressCreditConsultant:
            return 'inProgress-status'
        case QuestionnaireStatus.AcceptedCreditExpert:
        case QuestionnaireStatus.AcceptedCreditConsultant:
            return 'accepted-status'
        case QuestionnaireStatus.PreTrialCase:
            return 'pretrial-case'
        case QuestionnaireStatus.LawCourt:
            return 'law-court'
        case QuestionnaireStatus.CourtsDecision:
            return 'courts-decision'
        case QuestionnaireStatus.ActiveCredit:
            return 'active-credit'
        case QuestionnaireStatus.Delivery:
            return 'delivery'
        case QuestionnaireStatus.Hold:
            return 'hold-status'
        // case QuestionnaireStatus.Problem:
        //     return 'problem'
        default: return ''
    }
}

export function getQuestionnaireStatusText(status: QuestionnaireStatus) {
    const localizationStore = LocalizationStore.getInstance()

    switch (status) {
        case QuestionnaireStatus.Canceled:
            return localizationStore!.t!('Canceled')
        case QuestionnaireStatus.Done:
            return localizationStore!.t!('Done')
        case QuestionnaireStatus.Draft:
            return localizationStore!.t!('Draft')
        case QuestionnaireStatus.InProgressCreditConsultant:
            return localizationStore!.t!('InProgressCreditConsultant')
        case QuestionnaireStatus.AcceptedCreditConsultant:
            return localizationStore!.t!('AcceptedCreditConsultant')
        case QuestionnaireStatus.Scored:
            return localizationStore!.t!('Scored')
        case QuestionnaireStatus.InProgressCreditExpert:
            return localizationStore!.t!('InProgressCreditExpert')
        case QuestionnaireStatus.AcceptedCreditExpert:
            return localizationStore!.t!('AcceptedCreditExpert')
        case QuestionnaireStatus.Delivery:
            return localizationStore!.t!('Delivery')
        case QuestionnaireStatus.ActiveCredit:
            return localizationStore!.t!('ActiveCredit')
        case QuestionnaireStatus.PreTrialCase:
            return localizationStore!.t!('PreTrialCase')
        case QuestionnaireStatus.LawCourt:
            return localizationStore!.t!('LawCourt')
        case QuestionnaireStatus.CourtsDecision:
            return localizationStore!.t!('CourtsDecision')
        case QuestionnaireStatus.Hold:
            return localizationStore!.t!('Hold')
        default: return `status ${status}`
    }
}

export function getQuestionnaireStatusTextForList(status: QuestionnaireStatus) {
    const localizationStore = LocalizationStore.getInstance()

    switch (status) {
        case QuestionnaireStatus.Canceled:
            return localizationStore!.t!('CanceledForList')
        case QuestionnaireStatus.Done:
            return localizationStore!.t!('DoneForList')
        case QuestionnaireStatus.Draft:
            return localizationStore!.t!('DraftForList')
        case QuestionnaireStatus.InProgressCreditConsultant:
            return localizationStore!.t!('InProgressCreditConsultantForList')
        case QuestionnaireStatus.AcceptedCreditConsultant:
            return localizationStore!.t!('AcceptedCreditConsultantForList')
        case QuestionnaireStatus.Scored:
            return localizationStore!.t!('ScoredForList')
        case QuestionnaireStatus.InProgressCreditExpert:
            return localizationStore!.t!('InProgressCreditExpertForList')
        case QuestionnaireStatus.AcceptedCreditExpert:
            return localizationStore!.t!('AcceptedCreditExpertForList')
        case QuestionnaireStatus.Delivery:
            return localizationStore!.t!('Delivery')
        case QuestionnaireStatus.ActiveCredit:
            return localizationStore!.t!('ActiveCredit')
        case QuestionnaireStatus.PreTrialCase:
            return localizationStore!.t!('PreTrialCase')
        case QuestionnaireStatus.LawCourt:
            return localizationStore!.t!('LawCourt')
        case QuestionnaireStatus.CourtsDecision:
            return localizationStore!.t!('CourtsDecision')
        case QuestionnaireStatus.Hold:
            return localizationStore!.t!('Hold')
        default: return `status ${status}`
    }
}

export class QuestionnairePrefillData {
    constructor(
        pin: string,
        phoneNumber: string,
        termCountMonths: number
    ) {
        this.pin = pin
        this.phoneNumber = phoneNumber
        this.termCountMonths = termCountMonths
    }
    pin: string
    phoneNumber: string
    termCountMonths: number
}

export class PaginationRequest {
    constructor(
        page: number,
        pageSize: number,
        filter: any,
        sort: any) {
        this.page = page
        this.pageSize = pageSize
        this.filter = filter
        this.sort = sort
    }

    page: number
    pageSize: number
    filter: any
    sort: any
}

export class FindQRequest extends PaginationRequest {
    constructor(
        passportNumber: string,
        pin: string,
        exceptIds: Array<string>,
        page: number,
        pageSize: number,
        filter: any,
        sort: any) {
        super(page, pageSize, filter, sort)

        this.passportNumber = passportNumber
        this.pin = pin
        this.exceptIds = exceptIds
    }

    passportNumber: string
    pin: string
    phoneNumbers: Array<string>
    exceptIds: Array<string>
}

export interface IContentLink {
    id: string
    createDate: string
    updateDate: string
    link: string
    description: string
}
export class ContentLink {
    id: string
    createDate: string
    updateDate: string
    link: string
    description: string
}

export interface IQuestionnaire {
    id: string
    createDate: string
    updateDate: string
    status: QuestionnaireStatus
    credit: ICredit
    client: IClient
    comments: Array<IQuestionnaireComment>
    questionnaireUserHistoryItems: Array<IQuestionnaireUserHistoryItem>
    changeStatus(s: QuestionnaireStatus): void
    score: number
    termCountMonthsScoreJson: string
    dpdScore: string
    paymentRating: number
    dpdRating: number
    orderSource: string
    orderLink: string
    contentLinks: Array<IContentLink>
    affiliate: Affiliate
    inProgressByUserId: string
    externalKey: string
    agentCode: string
    agentAction: string
    imeiList: any
}

export class Questionnaire implements IQuestionnaire {
    id: string = ''
    createDate: string = ''
    updateDate: string = ''
    status: QuestionnaireStatus
    credit: ICredit
    client: IClient
    score: number = 0
    termCountMonthsScoreJson: string = ''
    dpdScore: string = ''
    paymentRating: number = 0
    dpdRating: number = 0
    orderSource: string = 'SRS'
    orderLink: string = ''
    comments: Array<IQuestionnaireComment> = new Array()
    questionnaireUserHistoryItems: Array<IQuestionnaireUserHistoryItem> = new Array()
    contentLinks: Array<IContentLink> = new Array()
    affiliate: Affiliate
    inProgressByUserId: string
    externalKey: string
    cancelReason?: CancelReason
    agentCode: string
    agentAction: string
    imeiList: any

    constructor() {
        this.credit = new Credit()
        this.client = new Client()
    }

    static create(data: QuestionnairePrefillData): IQuestionnaire {
        let q = new Questionnaire()
        q.client = Client.create(data.pin, data.phoneNumber)
        q.credit = Credit.create(data.termCountMonths)

        return q
    }

    changeStatus(s: QuestionnaireStatus): void {
        return
    }
}

export interface IQuestionnaireUserHistoryItem {
    id: string
    createDate: string
    userId: string
    userName: string
    status: QuestionnaireStatus
}

export interface IQuestionnaireComment {
    id: string
    createDate: string
    userName: string
    content: string
}

export interface IPenalty {
    amount: number
}

export interface ICredit {
    id: string
    createDate: string
    creditNumber: string
    products: Array<IProduct>
    creditCondition: ICreditCondition
    creditDetail: ICreditDetail
    payments: Array<Payment>
    penalties: Array<IPenalty>
    troubleEvents: Array<ITroubleEventSimple>
    questionnaire: IQuestionnaire
    courtDecision?: CourtDecision
}

export class Credit implements ICredit {
    constructor() {
        this.creditCondition = new CreditCondition()
    }

    static create(termCountMonths: number) {
        let c = new Credit()
        c.creditCondition.termCountMonths = termCountMonths
        return c
    }

    id: string
    createDate: string
    creditNumber: string
    products: Array<IProduct>
    creditCondition: ICreditCondition
    creditDetail: ICreditDetail
    payments: Array<Payment>
    penalties: Array<IPenalty>
    troubleEvents: Array<ITroubleEventSimple>
    questionnaire: IQuestionnaire
    courtDecision?: CourtDecision
}

export interface ICreditDetail {
    id: string,
    createDate: string,
    updateDate: string,
    dpd: number,
    balance: number,
    totalSum: number
}

export class CreditDetail implements ICreditDetail {
    id: string
    createDate: string
    updateDate: string
    dpd: number
    balance: number
    totalSum: number

}

export interface IBaseProduct {
    id: undefined | string
    externalKey: string
    name: string
    category: string
    price: number
    riskCategory: string
}

export interface IProduct extends IBaseProduct {
    count: number
}
export interface IClient {
    id: string
    externalKey: string
    name: string
    surname: string
    middleName: string
    birthday: string
    familyStatus: number
    workDescription: string
    salary: number
    revenue: number
    email?: string
    gender: number
    passport: IPassport
    addresses: Array<IAddress>
    phones: Array<IPhone>
    notes: string
    isNeedToVerify: boolean
}
export class Client implements IClient {
    constructor() {
        this.passport = new Passport()
        this.phones = []
    }

    static create(pin: string, phoneNumber: string): IClient {
        let c = new Client()
        c.passport.pin = pin
        c.phones.push(new Phone(phoneNumber, PhoneType.MobilePhone, true))

        return c
    }

    id: string
    externalKey: string
    name: string
    surname: string
    middleName: string
    birthday: string
    email: string
    gender: number
    passport: IPassport
    addresses: Array<IAddress>
    phones: Array<IPhone>
    familyStatus: number
    workDescription: string
    salary: number
    revenue: number
    notes: string
    isNeedToVerify: boolean
    bonusCardNumber: string
}
export interface IPassport {
    id: string
    pin: string
    series: string
    number: string
}

export class Passport implements IPassport {

    constructor() {
        this.pin = ''
        this.series = ''
        this.number = ''
    }
    id: string
    pin: string
    series: string
    number: string
}

export interface IPhone {
    id: string
    number: string
    phoneType: number
    isDefaultPhone: boolean
}

export class Phone implements IPhone {
    constructor(
        phoneNumber: string,
        phoneType: PhoneType,
        isDefaultPhone?: boolean
    ) {
        this.number = phoneNumber
        this.phoneType = phoneType
        this.isDefaultPhone = isDefaultPhone ? isDefaultPhone : false
    }

    id: string
    number: string
    phoneType: number
    isDefaultPhone: boolean
}

export interface IAddress {
    id: string
    countryName: string
    cityName: string
    districtName: string
    streetName: string
    building: string
    apartment: string
    isDefaultDeliveryAddress: boolean
    addressType: number
}
export class Address {
    id: string
    countryName: string
    cityName: string
    districtName: string
    streetName: string
    building: string
    apartment: string
    isDefaultDeliveryAddress: boolean
    addressType: number
}

export interface ITermMonthScore {
    Duration: string
    Score: number
}

export const enum PhoneType {
    OtherPhone = 0,
    HomePhone = 1,
    MobilePhone = 2,
    WorkPhone = 3
}

export const enum AddressType {
    OtherAddress = 0,
    HomeAddress = 1,
    WorkAddress = 2,
    RegistrationAddress = 3
}

export const enum Gender {
    Male = 0,
    Female = 1,
    NotSet = 500
}

export enum QuestionnaireStatus {
    Done = 0, // Завершено
    Canceled = 1, // Отклонена
    Draft = 2, // Черновик
    InProgressCreditConsultant = 3, // В работе
    AcceptedCreditConsultant = 4, // Одобрено CreditConsultant
    Scored = 5, // Оценено
    InProgressCreditExpert = 6, // В работе
    AcceptedCreditExpert = 7, // Одобрено CreditExpert
    Delivery = 8, // Доставка
    ActiveCredit = 9, // Активный кредит
    PreTrialCase = 10, // Досудебное дело
    LawCourt = 11, // Суд
    CourtsDecision = 12, // Решение суда
    Hold = 13, // Активный кредит по которому не начисляем пеню
}

export const enum FamilyStatus {
    Single = 0,
    Married = 1,
    UnMarried = 2,
    NotSet = 500
}

const ls = LocalizationStore.getInstance()

export function validate(formData: Questionnaire, errors: FormValidation) {
    if (formData.client.birthday) {
        let date = moment(formData.client.birthday, 'DD.MM.YYYY').format('DD.MM.YYYY')
        if ('Invalid date' === date) {
            errors.client['birthday'].addError(ls.t('Invalid date format. Should be dd/mm/yyyy'))
            date = moment.utc(formData.client.birthday).format()
        }
    }
    if (formData.credit.creditCondition.prepaymentSum) {
        let cTotalSum = parseFloat(formData.credit.products.map(x => x.count * x.price)
            .reduce(
                (a, b) =>
                    numOr0(a) + numOr0(b)).toFixed(2))
        if (formData.credit.creditCondition.prepaymentSum >= cTotalSum) {
            errors.credit['creditCondition']['prepaymentSum'].addError(
                ls.t('The amount of prepayment should not exceed the amount of the loan')
            )
        }
    }

    if (formData.client.phones.length > 1) {
        let phones = formData.client.phones
        let check = phones.filter(phone => {
            return phone.isDefaultPhone
        }).length > 1
        if (check) {
            errors.client['phones'].addError(ls.t('Should be only one default phone number'))
        }
    }

    if (formData.client.addresses.length > 1) {
        let addresses = formData.client.addresses
        let check = addresses.filter(address => {
            return address.isDefaultDeliveryAddress
        }).length > 1

        if (check) {
            errors.client['addresses'].addError(ls.t('Should be only one default delivery address'))
        }
    }

    return errors
}

export function transformErrors(errors: Array<AjvError>) {
    return errors.map((error: AjvError) => {
        if (error['name'] === 'required') {
            error['message'] = ls.t('is a required property')
        }
        if (error['params']['type'] === 'number') {
            error['message'] = ls.t('should be number')
        }
        if (error['params']['type'] === 'integer') {
            error['message'] = ls.t('should be integer')
        }
        if (error['name'] === 'pattern') {
            error['message'] = ls.t('invalid number format')
        }
        if (error['name'] === 'maxLength') {
            error['message'] = ls.t('maximum number of characters has been exceeded')
        }

        return error
    })
}

export function addDefaultAffiliate(list: Array<Affiliate>) {
    if (!list) {
        list = []
    }

    list.unshift(getDefaultAffiliate())

    return list
}

export function getQuestionnaireFormScheme(questionnaire: Questionnaire, affiliates: Array<Affiliate>) {
    let affiliatesLocal = toJS(affiliates)

    affiliatesLocal = addDefaultAffiliate(affiliatesLocal)
    let defaultAffiliate = affiliatesLocal
        .filter(x =>
            x.id ===
            (questionnaire && questionnaire.affiliate ?
                questionnaire.affiliate.id :
                getDefaultAffiliate().id))[0]

    return {
        type: 'object',
        required: [
            'credit',
            'client'
        ],
        properties: {
            credit: {
                title: ls.t!('credit'),
                type: 'object',
                required: [
                    'products',
                ],
                properties: {
                    // 'creditNumber': { 'title': ls.t!('creditNumber'), 'type': 'number' },
                    products: {
                        title: '',
                        type: 'array',
                        items: {
                            required: ['externalKey', 'name', 'price', 'count'],
                            type: 'object',
                            properties: {
                                'id': { 'type': 'string' },
                                'externalKey': {
                                    'title': ls.t!('externalProductKey'),
                                    'type': 'string',
                                    'maxLength': 100
                                },
                                'name': { 'title': ls.t!('name'), 'type': 'string', 'maxLength': 200 },
                                'price': { 'title': ls.t!('price'), 'type': 'number', 'maximum': 1000000000 },
                                'count': { 'title': ls.t!('count'), 'type': 'number', 'default': 1 },
                                'category': { 'title': ls.t!('category'), 'type': 'string' },
                                riskCategory: { 'title': ls.t!('riskCategory'), 'type': 'string' }
                            }
                        },
                        // 'minItems': 1
                    },
                    creditCondition: {
                        required: [
                            'termCountMonths',
                            'prepaymentSum',
                            'creditPercentPerMonth',
                            'creditPercentDiscountPerMonth'
                        ],
                        'title': '', // ls.t!('creditCondition'),
                        'type': 'object',
                        properties: {
                            'termCountMonths': {
                                'title': ls.t!('termCountMonths'),
                                'type': 'integer',
                                'minimum': 1,
                                'maximum': 100,
                                'default': 6
                            },
                            'prepaymentSum': {
                                'title': ls.t!('prepaymentSum'),
                                'type': 'number',
                                'minimum': 0,
                                'default': 0
                            },
                            'creditPercentPerMonth': {
                                'title': ls.t!('creditPercentPerMonth'),
                                'type': 'number',
                                'minimum': 0,
                                'default': 1.5
                            },
                            'creditPercentDiscountPerMonth': {
                                'title': ls.t!('creditPercentDiscountPerMonth'),
                                'type': 'number',
                                'minimum': 0,
                                'default': 0
                            }
                        }
                    }
                }
            },
            client: {
                'type': 'object',
                'title': ls.t!('clientInfo'),
                'required': [
                    'phones',
                    'passport'
                ],
                properties: {
                    'externalKey': {
                        'title': ls.t!('externalClientKey'),
                        'type': 'string'
                    },
                    'bonusCardNumber': {
                        'type': 'string',
                        'title': ls.t!('bonusCardNumber')
                    },
                    'passport': {
                        'type': 'object',
                        'title': ls.t!('passportData'),
                        'required': ['pin', 'number'],
                        'properties': {
                            'pin': { 'title': ls.t!('pin'), 'type': 'string', 'maxLength': 7 },
                            'series': { 'title': ls.t!('passportSeries'), 'type': 'string' },
                            'number': {
                                'title': ls.t!('passportNumber'),
                                'type': 'string',
                                'minLength': 6,
                                'maxLength': 8
                            }
                        },
                    },

                    'surname': { 'title': ls.t!('surname'), 'type': 'string' },
                    'name': { 'title': ls.t!('Name'), 'type': 'string' },
                    'middleName': { 'title': ls.t!('middleName'), 'type': 'string' },
                    'birthday': { 'title': `${ls.t!('birthday')} dd.mm.yyyy`, 'type': 'string' },
                    'gender': {
                        'title': ls.t!('gender'),
                        'type': 'number',
                        'enum': [
                            Gender.NotSet,
                            Gender.Male,
                            Gender.Female
                        ],
                        'enumNames': [
                            ls.t!('Not Set'),
                            ls.t!('Male'),
                            ls.t!('Female')
                        ],
                        'default': Gender.NotSet
                    },
                    'familyStatus': {
                        'title': ls.t!('familyStatus'),
                        'type': 'number',
                        'enum': [
                            FamilyStatus.NotSet,
                            FamilyStatus.Single,
                            FamilyStatus.Married,
                            FamilyStatus.UnMarried
                        ],
                        'enumNames': [
                            ls.t!('Not Set'),
                            ls.t!('Single'),
                            ls.t!('Married'),
                            ls.t!('UnMarried')
                        ],
                        'default': FamilyStatus.NotSet
                    },
                    'workDescription': {
                        'title': ls.t!('workDescription'),
                        'type': 'string'
                    },
                    'salary': {
                        'title': ls.t!('salary'),
                        'type': 'integer'
                    },
                    'revenue': {
                        'title': ls.t!('revenue'),
                        'type': 'integer'
                    },
                    'isNeedToVerify': {
                        'title': ls.t!('isNeedToVerifyClient'),
                        'type': 'boolean'
                    },
                    'addresses': {
                        'title': ls.t!('contactInfo'),
                        'type': 'array',
                        'items': {
                            'title': ls.t('addresses'),
                            'type': 'object',
                            'properties': {
                                'id': { 'type': 'string' },
                                'countryName': { 'title': ls.t!('countryName'), 'type': 'string' },
                                'cityName': { 'title': ls.t!('cityName'), 'type': 'string' },
                                'districtName': { 'title': ls.t!('districtName'), 'type': 'string' },
                                'streetName': { 'title': ls.t!('streetName'), 'type': 'string' },
                                'building': { 'title': ls.t!('building'), 'type': 'string' },
                                'apartment': { 'title': ls.t!('apartment'), 'type': 'string' },
                                'isDefaultDeliveryAddress': {
                                    'title': ls.t!('isDefaultDeliveryAddress'),
                                    'type': 'boolean'
                                },
                                'addressType': {
                                    'title': ls.t!('addressType'),
                                    'type': 'number',
                                    'enum': [
                                        AddressType.HomeAddress,
                                        AddressType.WorkAddress,
                                        AddressType.RegistrationAddress,
                                        AddressType.OtherAddress
                                    ],
                                    'enumNames': [
                                        ls.t!('HomeAddress'),
                                        ls.t!('WorkAddress'),
                                        ls.t!('RegistrationAddress'),
                                        ls.t!('OtherAddress')
                                    ],
                                    'default': AddressType.HomeAddress
                                }
                            }
                        },
                        'minItems': 1
                    },
                    'phones': {
                        'title': ls.t!('phones'),
                        'type': 'array',
                        'items': {
                            'title': '',
                            'type': 'object',
                            'required': ['number'],
                            'properties': {
                                'id': { 'type': 'string' },
                                'number': {
                                    'title': ls.t!('phoneNumber'),
                                    'type': 'string',
                                    'maxLength': 18,
                                    'pattern': '^[\\s]*[+]?[0-9()\-\\s]{4,17}[\\s]*$'
                                },
                                'phoneType': {
                                    'title': ls.t!('phoneType'),
                                    'type': 'number',
                                    'enum': [
                                        PhoneType.HomePhone,
                                        PhoneType.MobilePhone,
                                        PhoneType.WorkPhone,
                                        PhoneType.OtherPhone
                                    ],
                                    'enumNames': [
                                        ls.t!('HomePhone'),
                                        ls.t!('MobilePhone'),
                                        ls.t!('WorkPhone'),
                                        ls.t!('OtherPhone')
                                    ],
                                    default: PhoneType.MobilePhone
                                },
                                'isDefaultPhone': {
                                    'title': ls.t!('isDefaultPhone'),
                                    'type': 'boolean'
                                },
                            }
                        },
                        'minItems': 1
                    },
                    'email': {
                        'title': ls.t!('email'),
                        'type': 'string',
                        'format': 'email'
                    },
                    'notes': {
                        'title': ls.t!('notes'),
                        'type': 'string'
                    }
                }
            },
            affiliate: {
                title: ls.t!('Affiliate'),
                type: 'object',
                properties: {
                    id: {
                        title: `${ls.t('Current')} ${ls.t('id')}`,
                        type: 'string'
                    },
                    affiliateList: {
                        title: ' ',
                        type: 'object',
                        properties: {
                            affiliateId: {
                                title: `${ls.t('selectAffiliate')}`,
                                type: 'string',
                                enum: affiliatesLocal.map(x => x.id),
                                enumNames: affiliatesLocal
                                    .map(x =>
                                        `${x.id} ${x.name} [${x.isActive ? ls.t('Active') : ls.t('Not Active')}] 
                                            ${ls.t('Merchant')}: ${x.merchant.name} 
                                            [${x.merchant.isActive ? ls.t('Active') : ls.t('Not Active')}]`
                                    ),
                                default: defaultAffiliate ? defaultAffiliate.id : null,
                                uniqueItems: true
                            },
                        }
                    }
                }
            },
            agentCode: {
                type: 'string'
            },
            agentAction: {
                type: 'string'
            }
        }
    }
}

export function getEventQuestionnaireFormScheme(questionnaire: Questionnaire, affiliates: Array<Affiliate>) {
    let eventSchema = JSON
        .parse(
            JSON
                .stringify(getQuestionnaireFormScheme(questionnaire, affiliates)))

    eventSchema['properties']['credit']['properties']['creditDetail'] = {
        'title': ls.t!('creditDetail'),
        'type': 'object',
        'properties': {
            'dpd': {
                'title': ls.t!('dpd'),
                'type': 'number',
                'minimum': 0,
                'default': 0
            },
            'balance': {
                'title': ls.t!('balance'),
                'type': 'number',
                'minimum': 0,
                'default': 0
            },
            'totalSum': {
                'title': ls.t!('totalSum'),
                'type': 'number',
                'minimum': 0,
                'default': 0
            }
        }
    }
    return eventSchema
}

export function getQuestionnaireFormUIScheme(affilites: Array<Affiliate>) {
    return {
        id: {
            'ui:readonly': true,
            'ui:help': ls.t('uneditable'),
            'ui:widget': 'hidden'
        },
        credit: {
            // 'creditNumber': {
            //     'ui:readonly': true
            // },
            products: {
                'ui:readonly': true,
                'ui:options': {
                    addable: false,
                    orderable: false,
                    removable: false
                },
                'items': {
                    'id': {
                        'ui:widget': 'hidden'
                    },
                    'externalKey': {
                        'ui:autofocus': true
                    },
                    riskCategory: {
                        'ui:readonly': true
                    }
                },
                'classNames': 'stretchArray'
            },
            creditCondition: {
                'termCountMonths': {
                    'ui:widget': 'hidden'
                },
                'prepaymentSum': {
                    'ui:widget': 'hidden'
                },
                'creditPercentPerMonth': {
                    'ui:widget': 'hidden'
                },
                'creditPercentDiscountPerMonth': {
                    'ui:widget': 'hidden'
                },
                'paymentsScheduleJson': {
                    'ui:widget': 'hidden'
                }
            }
        },
        client: {
            addresses: {
                'items': {
                    'id': {
                        'ui:widget': 'hidden'
                    }
                }
            },
            phones: {
                'items': {
                    'id': {
                        'ui:widget': 'hidden'
                    }
                },
                'salary': {
                    'ui:widget': 'updown'
                },
                'revenue': {
                    'ui:widget': 'updown'
                },
                'notes': {
                    'ui:widget': 'textarea'
                },
                'birthday': {
                    'ui:placeholder': ls.t('dd/mm/yyyy')
                },

            },
            workDescription: {
                'classNames': 'legend'
            },
            status: {
                'ui:widget': 'radio',
                'ui:options': {
                    'inline': true
                }
            }
        },
        affiliate: {
            id: {
                'ui:readonly': true,
                'ui:widget': (props: any) => {

                    if (props.value && props.value !== getDefaultAffiliate().id) {
                        return (
                            <Link
                                to={`/affiliate/${props.value}`}
                            >
                                {props.value}
                            </Link>
                        )
                    } else {
                        return LocalizationStore.getInstance().t('no data')
                    }
                }
            },
            affiliateList:
            {
                affiliateId: {
                    'ui:enumDisabled': affilites.filter(x => !x.isActive || !x.merchant.isActive).map(x => x.id),
                }
            }
        },
        agentCode: {
            'ui:widget': 'hidden'
        },
        agentAction: {
            'ui:widget': 'hidden'
        }
    }
}

export function getQuestionnaireReadonlyFormUIScheme(): any {
    return {
        id: {
            'ui:readonly': true
        },
        credit: {
            'ui:readonly': true,
            products: {
                'items': {
                    'id': {
                        'ui:widget': 'hidden'
                    },
                    riskCategory: {
                        'ui:readonly': true
                    }
                },
                'classNames': 'stretchArrayReadonly'
            },
            creditCondition: {
                'termCountMonths': {
                    'ui:widget': 'hidden'
                },
                'prepaymentSum': {
                    'ui:widget': 'hidden'
                },
                'creditPercentPerMonth': {
                    'ui:widget': 'hidden'
                },
                'creditPercentDiscountPerMonth': {
                    'ui:widget': 'hidden'
                },
                'paymentsScheduleJson': {
                    'ui:widget': 'hidden'
                }
            }
        },
        client: {
            'ui:readonly': true,
            'addresses': {
                'items': {
                    'id': {
                        'ui:widget': 'hidden'
                    }
                }
            },
            phones: {
                'items': {
                    'id': {
                        'ui:widget': 'hidden'
                    }
                },
                'ui:readonly': true,
            }
        },
        affiliate: {
            id: {
                'ui:readonly': true,
                'ui:widget': (props: any) => {
                    if (props.value && props.value !== getDefaultAffiliate().id) {
                        return (
                            <Link
                                to={`/affiliate/${props.value}`}
                            >
                                {props.value}
                            </Link>
                        )
                    } else {
                        return LocalizationStore.getInstance().t('no data')
                    }
                }
            },
            affiliateList:
            {
                'ui:readonly': true,
            }
        },
        agentCode: {
            'ui:widget': 'hidden'
        },
        agentAction: {
            'ui:widget': 'hidden'
        }
    }
}

export function getQuestionnaireCallerFormUIScheme(affilites: Array<Affiliate>) {
    return {
        'id': {
            'ui:readonly': true
        },
        'credit': {
            'ui:readonly': true,
            'products': {
                'items': {
                    'id': {
                        'ui:widget': 'hidden'
                    },
                    riskCategory: {
                        'ui:readonly': true
                    }
                },
                'classNames': 'stretchArrayReadonly'
            },
            'creditCondition': {
                'termCountMonths': {
                    'ui:widget': 'hidden'
                },
                'prepaymentSum': {
                    'ui:widget': 'hidden'
                },
                'creditPercentPerMonth': {
                    'ui:widget': 'hidden'
                },
                'creditPercentDiscountPerMonth': {
                    'ui:widget': 'hidden'
                },
                'paymentsScheduleJson': {
                    'ui:widget': 'hidden'
                }
            }
        },
        'client': {
            'ui:readonly': false,
            'isNeedToVerify': {
                'ui:widget': 'hidden'
            },
            'addresses': {
                'items': {
                    'id': {
                        'ui:widget': 'hidden'
                    }
                }
            },
            'phones': {
                'items': {
                    'id': {
                        'ui:widget': 'hidden'
                    }
                }
            }
        },
        'affiliate': {
            'id': {
                'ui:readonly': true,
                'ui:widget': (props: any) => {
                    if (props.value && props.value !== getDefaultAffiliate().id) {
                        return (
                            <Link
                                to={`/affiliate/${props.value}`}
                            >
                                {props.value}
                            </Link>
                        )
                    } else {
                        return LocalizationStore.getInstance().t('no data')
                    }
                }
            },
            'affiliateList':
            {
                'affiliateId': {
                    'ui:enumDisabled': affilites.filter(x => !x.isActive || !x.merchant.isActive).map(x => x.id),
                }
            }
        }
    }
}

export function getQuestionnaireCreditExpertFormUIScheme(affilites: Array<Affiliate>) {
    return {
        'id': {
            'ui:readonly': true
        },
        'credit': {
            // 'creditNumber': {
            //     'ui:readonly': true
            // },
            'products': {
                'items': {
                    'id': {
                        'ui:widget': 'hidden'
                    },
                    riskCategory: {
                        'ui:readonly': true
                    }
                },
                'classNames': 'stretchArrayReadonly'
            },
            'creditCondition': {
                'termCountMonths': {
                    'ui:widget': 'hidden'
                },
                'prepaymentSum': {
                    'ui:widget': 'hidden'
                },
                'creditPercentPerMonth': {
                    'ui:widget': 'hidden'
                },
                'creditPercentDiscountPerMonth': {
                    'ui:widget': 'hidden'
                },
                'paymentsScheduleJson': {
                    'ui:widget': 'hidden'
                }
            }
        },
        'client': {
            'ui:readonly': true,
            'addresses': {
                'ui:readonly': true,
                'items': {
                    'id': {
                        'ui:widget': 'hidden'
                    }
                }
            },
            'phones': {
                'ui:readonly': true,
                'items': {
                    'id': {
                        'ui:widget': 'hidden'
                    }
                }
            }
        },
        'affiliate': {
            'id': {
                'ui:readonly': true,
                'ui:widget': (props: any) => {
                    if (props.value && props.value !== getDefaultAffiliate().id) {
                        return (
                            <Link
                                to={`/affiliate/${props.value}`}
                            >
                                {props.value}
                            </Link>
                        )
                    } else {
                        return LocalizationStore.getInstance().t('no data')
                    }
                }
            },
            'affiliateList':
            {
                'affiliateId': {
                    'ui:enumDisabled': affilites.filter(x => !x.isActive || !x.merchant.isActive).map(x => x.id),
                }
            }
        }
    }
}

export function prepareQuestionnaire(q?: Questionnaire | null) {
    if (!q) {
        q = new Questionnaire()
        return
    }

    if (!q.client.addresses || !q.client.addresses.length) {
        q.client.addresses = new Array<IAddress>()
        q.client.addresses.push({
            id: '',
            countryName: '',
            cityName: '',
            districtName: '',
            streetName: '',
            building: '',
            apartment: '',
            isDefaultDeliveryAddress: false,
            addressType: 0
        })
    }
    if (!q.client.phones || !q.client.phones.length) {
        q.client.phones.push(
            {
                id: '',
                number: '',
                phoneType: 0,
                isDefaultPhone: false
            }
        )
    }

    if (!q.client.phones || !q.client.phones.length) {
        q.client.phones = new Array<IPhone>()
        q.client.phones.push({
            id: '',
            isDefaultPhone: false,
            number: '',
            phoneType: PhoneType.HomePhone
        })
    }

    q.createDate = q.createDate ?
        DateTimeHelper
            .formatDateTimeForList(q.createDate.toString().replace('Z', '')) :
        DateTimeHelper
            .formatDateTimeForList(new Date().toString())

    q.updateDate = q.updateDate ?
        DateTimeHelper
            .formatDateTimeForList(q.updateDate.toString().replace('Z', '')) :
        ''

    q.credit.createDate = q.credit.createDate ?
        DateTimeHelper.formatDateForList(q.credit.createDate) :
        DateTimeHelper
            .formatDateTimeForList(new Date().toString())

    q.client.birthday = DateTimeHelper.formatDateForList(q.client.birthday)

    removeNull(q)

    if (!q.credit.creditCondition) {
        q.credit.creditCondition = new CreditCondition()
    }

    if (!q.affiliate) {
        q.affiliate = getDefaultAffiliate()
    }

    if (!q.client.email) {
        q.client.email = undefined
    }

    return q
}

export function getCreditLimitByEmail() {
    const localizationStore = LocalizationStore.getInstance()
    const questionnairesStore = QuestionnairesStore.getInstance()
    // const configStore = ConfigStore.getInstance()
    return (
        <div className="creditLimitByEmailBlock">
            <p className="text-center">
                {localizationStore.t('CreditLimitByEmail')} : {
                    questionnairesStore.getCreditLimit || questionnairesStore.getCreditLimit === 0 ?
                        `${questionnairesStore.getCreditLimit} AZN` :
                        localizationStore!.t!('no data yet')}
            </p>
        </div>
    )
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Model/Questionnaire.tsx